<template>
  <div>
    <nav-title :color="false" :title="'Parent Goals'" />
    <section class="container">
      <detail-plan
        v-if="state"
        class="container px-sm-5"
        :planAnswers="getPlanAnswers"
        :Mid="Mid"
        :skillName="getSkillName.text"
      />
      <new-plan
        class="container px-sm-5"
        v-else
        :skillQuest="getPlanQuestionList"
        :Mid="Mid"
        :skillName="getSkillName.text"
      />
    </section>
  </div>
</template>
<script>
import navTitle from '@/components/general/navTitle.vue';
import newPlan from '@/components/planning/newPlan.vue';
import detailPlan from '@/components/planning/detailPlan.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import store from '@/store';

export default {
  components: {
    navTitle,
    newPlan,
    detailPlan,
  },
  data() {
    return {
      Mid: this.$route.params.Mid,
      state: null,
    };
  },
  methods: {
    ...mapActions('planning', ['FetchPlanQuestionList', 'FetchSkillName', 'FetchPlanAnswers']),
    ...mapMutations('general', ['setIsCharging']),
    getAnswers() {
      let responses = false;
      this.getPlanAnswers.forEach((element) => {
        if (element.parent_reponses) responses = true;
      });
      return responses;
    },
    reloadAnswers() {
      let skill = this.$route.params.Mid;
      let parent = this.getUserId;
      let data = { parent: parent, skill: skill };
      this.setIsCharging(true);
      Promise.all([
        this.FetchPlanQuestionList(skill),
        this.FetchSkillName(skill),
        this.FetchPlanAnswers(data),
      ]).then(() => {
        this.setIsCharging(false);
        this.state = true;
      });
    },
  },
  mounted() {
    this.state = this.getAnswers();
  },
  computed: {
    ...mapGetters('planning', ['getPlanQuestionList', 'getSkillName', 'getPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
  },
  beforeRouteEnter(to, from, next) {
    let skill = to.params.Mid;
    let parent = store.getters['user/getUserId'];
    let data = { parent: parent, skill: skill };
    Promise.all([
      store.dispatch('planning/FetchPlanQuestionList', skill),
      store.dispatch('planning/FetchSkillName', skill),
      store.dispatch('planning/FetchPlanAnswers', data),
    ]).then(() => {
      next();
    });
  },
};
</script>
